import { useState } from 'react'
import DropDownList from '../DropDownList'
import Search from '../Search'
import { useGeoState } from '../GeoProvider'
import styles from './MapOptions.module.scss'
import Select,{ components } from 'react-select'
  // Custom Option component with checkbox
const CheckboxOption = (props) => {
  return (
    <components.Option {...props} tabIndex={0} >
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => {}}
        style={{ marginRight: 8 }}
        tabIndex={-1} // Optional: checkbox itself may not need to be focusable
      />
      {props.label}
    </components.Option>
  )
}
const RadioButtonOption = (props) => {
  return (
    <components.Option {...props} tabIndex={0} >
      <input
        type="radio"
        checked={props.isSelected}
        onChange={() => {}}
        style={{ marginRight: 8 }}
        tabIndex={-1} // Optional: checkbox itself may not need to be focusable
      />
      {props.label}
    </components.Option>
  )
}
const CustomMenuList = (props) => {
  const { children, selectProps } = props;
  return (
    <components.MenuList {...props} tabIndex={0} className={styles.menuList} >
       {children}
       <div style={{position: 'sticky',bottom: 0,zIndex: 1,background: '#fff',padding: '10px',borderTop: '1px solid #ccc',display: 'flex',justifyContent: 'space-between', }}>
        <button tabIndex={0}  onClick={props.onClear} className={styles.buttonClassClose}>Clear</button>
        <button tabIndex={0}  onClick={props.onApply} className={styles.buttonClassApply}>Apply</button>
      </div>
     
     
    </components.MenuList>
  );
};

const MapOptionsBirthTrend = ({getComorbFilter,regionDisplayOptions,
  entity, activeZip3,searchPlaceholder='Search State or County',geo_type,filter_type}) => {  
    let ageBucketOptions=[]
    let comorbOptions=[]
    let compliOptions=[]
    let trimesterOptions=[]
    
    getComorbFilter.map((state) => {
      let obj={value:state.data_id.toString(),label:state.display_value}
      if(state.category_name==="COMORBIDITY")
      {
        comorbOptions.push(obj)
      }
      else if(state.category_name==="COMPLICATION")
      {
        compliOptions.push(obj)
      }
      else if(state.category_name==="AGEGENDER")
      {
        ageBucketOptions.push(obj)
      }
      else if(state.category_name==="TRIMESTER")
      {
        trimesterOptions.push(obj)
      }
    })
  const {
    regionSelected,
    setRegionSelected,
    getComorbState,
    setComorbState,
    getAgeState,
    setAgeState,
    getTrimesterState,
    setTrimesterState,
  } = useGeoState()
  const groupedOptions = [
  {
    label: 'Comorbidity',
    options: comorbOptions
  },
  {
    label: 'Complications',
    options: compliOptions
  }
];
  const [selectedAgeOptions, setSelectedAgeOptions] = useState(getAgeState)
  const [selectedTrimesterOptions, setSelectedTrimesterOptions] = useState(getTrimesterState)
  const [getComorbOptions, setComorbOptions] = useState(getComorbState)
   const [searchCriteria, setSearchCriteria] = useState([])
   
 
  const changeHandlerComorb = (e) => {
    setComorbOptions(e)
  };
 const formatGroupLabel = (data) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} tabIndex={-1} >
    <span>{data.label}</span>
    {/* <Tooltip title={`More info about ${data.label}`} placement="right">
      <AiOutlineInfoCircle title={`Info about ${data.label}`} style={{ cursor: 'pointer', color: '#007bff' }} />
    </Tooltip> */}
  </div>

)
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderRadius: '4px',
      border: '1px solid #4B4D4F',
      boxSizing: 'border-box',
      cursor: 'pointer',
    }),
    option: (base, state) => ({
      ...base,
      color: '#1e2022',
      backgroundColor: 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: 'pointer',
      fontWeight: state.isSelected ? 'bold' : '',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
        cursor: 'pointer',
        padding: '0px 0px 0px 5px',
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'white',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      backgroundColor: '#002677',
      borderRadius: '100px',
      width: '32px',

      '&:hover': {
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
      },
    }),
    groupHeading: (provided) => ({
    ...provided,
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '5px 10px',
    color:'black'
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: 60, // or whatever height is appropriate
    overflowY: 'auto',
    flexWrap: 'wrap', // ensures tags wrap to new lines
    display: 'flex'
  }),
  }

   const onApplyComorb = () => {
      setComorbState(getComorbOptions)
  };
 
  const onClearComorb = () => {
    setComorbOptions([])
    setComorbState([])
  };

  function changeHandlerAge(e) {
    setSelectedAgeOptions(e)
    setAgeState(e)
  }
  function changeHandlerTrimester(e) {
    setSelectedTrimesterOptions(e)
    setTrimesterState(e)

  }
  
  return (
    <div className={styles.base}>
     
      <div  className={styles.pageDiseaseList}> 
      <div  >
        <p>Area </p>
         
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            setRegionSelected(e.target.value)            
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
        </div>
        <div  style={{
         minWidth:'30%',
         maxWidth: '30%',
         marginBottom: '24px',
         borderRadius: '4px',
         boxSizing: 'border-box',

         marginRight: '1.5%',
         marginTop: '1px',
         cursor: 'pointer',
       }} tabIndex={0}>
         
            <p>Comorbidity and Complications</p>
      <Select
        options={groupedOptions}
        formatGroupLabel={formatGroupLabel}
         styles={colourStyles}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option: CheckboxOption,MenuList: (props) => (
              <CustomMenuList 
              {...props}
                onApply={onApplyComorb} 
                onClear={onClearComorb}/>
              ) }}
        value={getComorbOptions}
        onChange={changeHandlerComorb}
        placeholder="Select conditions..."
      />
     
        </div>
        {filter_type==='prenatal'&&<div 
         style={{
         
          minWidth:'20%',
         maxWidth: '20%',
          marginBottom: '24px',
          borderRadius: '4px',
          //border: '1px solid #4B4D4F',
          boxSizing: 'border-box',

          marginRight: '1.5%',
          marginTop: '1px',
          cursor: 'pointer',
        }}>
        <p>Trimester</p>
        <Select
              // isMulti
              options={trimesterOptions}
              onChange={changeHandlerTrimester}
              value={selectedTrimesterOptions}
              placeholder={`Select Trimester(s)`}
              styles={colourStyles}
              components={{ Option: RadioButtonOption}}
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
              
            />
        </div>}
        <div 
         style={{
         
         minWidth:'20%',
         maxWidth: '20%',
          marginBottom: '24px',
          borderRadius: '4px',
          //border: '1px solid #4B4D4F',
          boxSizing: 'border-box',
          marginRight: '1.5%',
          marginTop: '1px',
          cursor: 'pointer',
        }}>
        <p>Age</p>
        <Select
              options={ageBucketOptions}
              onChange={changeHandlerAge}
              value={selectedAgeOptions}
              placeholder={`Select Age(s)`}
              styles={colourStyles}
              components={{ Option: RadioButtonOption }}
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
            />
        </div>
     
      </div>
     
    
      <div className={styles.pageHeaderSearch}>
         
            <p>Search Location</p>
            { activeZip3 !==undefined && entity ==='birthtrend' && (
              <Search
                criteria={searchCriteria}
                onChange={setSearchCriteria}
                entity={entity}
                activeMetros={null}
                placeholder={searchPlaceholder}
                activeZip3={activeZip3}
                showMSAs={false}
                showCounties={true}
                showZip3={false}
              />
            )}
        </div>
        
    </div>
  )
}

export default MapOptionsBirthTrend
